import { Link } from "react-router-dom";
import { allArticles, formatViews, getHotArticles, getCategoryById } from "@/lib/articles";

export default function BrandIntro() {
  const hotList = getHotArticles(5);
  const totalViews = allArticles.reduce((sum, item) => sum + item.views, 0);

  const stats = [
    { label: "内容篇数", value: `${allArticles.length}+` },
    { label: "覆盖分类", value: "3 大领域" },
    { label: "累计阅读", value: formatViews(totalViews) },
  ];

  return (
    <section className="w-full rounded-lg bg-secondary-950 p-5 md:p-8">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-5">
        <div className="lg:col-span-3">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500/20 px-3 py-1 text-xs font-medium text-primary-300">
            <i className="ri-information-line w-4 h-4 flex items-center justify-center"></i>
            关于鲁啊鲁
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold text-background-50 md:text-3xl">
            一个多领域的内容聚合平台
          </h2>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-200/80 md:text-base">
            鲁啊鲁致力于为用户提供丰富的资讯和内容，覆盖文化、娱乐、生活等多个领域。我们希望用简洁清晰的呈现方式，
            帮助每一位读者在碎片化的时间里，也能读到有质量、有温度的内容。
          </p>
          <div className="mt-7 grid grid-cols-3 gap-4">
            {stats.map((stat) => (
              <div key={stat.label}>
                <p className="font-heading text-xl font-bold text-primary-300 md:text-2xl">
                  {stat.value}
                </p>
                <p className="mt-1 text-xs text-background-200/70">{stat.label}</p>
              </div>
            ))}
          </div>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
            >
              了解我们
            </Link>
            <Link
              to="/contact"
              className="rounded-full border border-secondary-700 px-5 py-2.5 text-sm font-medium text-background-100 transition-colors hover:border-primary-500 hover:text-primary-300 whitespace-nowrap cursor-pointer"
            >
              联系我们
            </Link>
          </div>
        </div>

        <div className="lg:col-span-2">
          <div className="rounded-lg bg-secondary-900 p-4 md:p-5">
            <h3 className="flex items-center gap-2 font-heading text-base font-semibold text-background-50">
              <i className="ri-fire-line w-5 h-5 flex items-center justify-center text-accent-400"></i>
              本周热门榜
            </h3>
            <ul className="mt-4 space-y-3.5">
              {hotList.map((article, index) => {
                const category = getCategoryById(article.categoryId);
                return (
                  <li key={article.id}>
                    <Link
                      to={`/detail/${article.id}`}
                      className="group flex items-start gap-3"
                    >
                      <span
                        className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                          index === 0
                            ? "bg-primary-500 text-background-50"
                            : "bg-secondary-800 text-background-200"
                        }`}
                      >
                        {index + 1}
                      </span>
                      <span className="min-w-0">
                        <span className="line-clamp-2 text-sm text-background-100 group-hover:text-primary-300 transition-colors">
                          {article.title}
                        </span>
                        <span className="mt-0.5 block text-xs text-background-200/50">
                          {category?.name} · {formatViews(article.views)} 阅读
                        </span>
                      </span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}